// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-title[data-v-394dc9b4] {\n  position: sticky;\n  top: 66px;\n  background: #44484c;\n  z-index: 2;\n}\n", ""]);
// Exports
module.exports = exports;
